import React from 'react';

function Contact() {
  const contactInfo = [
    {
      title: "Visit Us",
      details: [
        "Level 35,",
        "West Tower World Trade Center",
        "No.1 Bank of Ceylon Mawatha",
        "Colombo 00100"
      ],
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      title: "Contact Information",
      details: [
        "Phone: (+94) 777 997 642",
        "",
        "Email: info@stargateship.com",
        ""
      ],
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      )
    },
    {
      title: "Business Hours",
      details: [
        "Monday - Friday: 8:00 AM - 8:00 PM",
        "Saturday: 8:00 AM - 12:00 PM",
        "Sunday: Closed"
      ],
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ];

  return (
    <section id="contact" className="section-padding bg-ash-dark">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="heading-secondary mb-6">
            <span className="text-red">Contact</span> Us
          </h2>
          <p className="text-xl text-gray-light max-w-3xl mx-auto">
            Have questions about our services? Reach out to our team and we'll get back to you promptly.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {contactInfo.map((info, index) => (
            <div key={index} className="bg-ash rounded-2xl p-8 border border-red/20">
              <div className="w-12 h-12 bg-gradient-to-r from-red to-orange rounded-lg flex items-center justify-center mb-6">
                <div className="text-white">{info.icon}</div>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">{info.title}</h3>
              <ul className="space-y-2">
                {info.details.map((detail, detailIndex) => (
                  <li key={detailIndex} className="text-gray-light">{detail}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}

export default Contact;